module.exports = __webpack_public_path__ + "media/images/mobile/contact/1-5642145c484dbb72298d182da6d76a79.jpg";